import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    startLoginEmailPassword
} from '../../actions/auth';
import minegocio from '../../imgs/logo-mi-negocio-f.png'
import seccion from '../../imgs/seccion_amarilla.png'

export const LoginScreen = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector(state => state.ui);
    const [passShowedLogin, setPassShowedLogin] = useState(false)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(startLoginEmailPassword(email, password));
    }

    useEffect(() => {
    }, [])

    return (
        <>
            <div className='row p-3 pl-4' style={{height: "100vh"}}>
                <div className='col-12 d-flex justify-content-center'>
                    <div className='text-center bg-white p-2' style={{ maxWidth: "300px", height: "fit-content", borderRadius: "10px" }}>
                        <div className='pt-3 mt-3'>
                            <img src={seccion} className="img-fluid"
                                alt="Task logo" width="70%" style={{ borderRadius: "10px" }} />
                        </div>
                        <div className='pt-1'>
                            <img src={minegocio} className="img-fluid"
                                alt="Task logo" width="70%" style={{ borderRadius: "10px" }} />
                        </div>
                        <form onSubmit={handleLogin}>
                            <div className="form-outline mt-4 mb-4 text-center">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}>
                                            <i className="fas fa-user"></i>
                                        </span>
                                    </div>
                                    <input type="text"
                                        placeholder="Correo"
                                        name="email"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        className="form-control form-control-lg"
                                        autoComplete="off"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </div>

                            </div>
                            <div className="form-outline mb-3 text-center">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}>
                                            <i className="fas fa-key"></i>
                                        </span>
                                    </div>
                                    <input
                                        type={passShowedLogin ? "text" : "password"}
                                        placeholder="Contraseña"
                                        name="password"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        className="form-control form-control-lg"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)} />
                                    <div className="input-group-append">
                                        <button className="btn" type="button"
                                            style={{ color: 'black', background: '#ffd900', borderColor: '#ffd900' }}
                                            onClick={() => setPassShowedLogin(!passShowedLogin)}>
                                            <i className={passShowedLogin ? "fa fa-eye-slash" : "fa fa-eye"}
                                                aria-hidden="true" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center text-lg-start mt-4 mb-2 pt-2">
                                <button type="submit" className="btn btn-primary btn-large" disabled={loading}
                                    style={{
                                        'paddingLeft': '2.5rem', 'paddingRight': '2.5rem', fontSize: '18px',
                                        color: 'black', background: '#ffd900', borderColor: '#ffd900'
                                    }}>
                                    Iniciar sesión
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}